import { Alert } from 'react-bootstrap'
import * as H from 'history'
import  React from 'react'
import { ClaimController } from '../../../../controllers/ClaimController'
import { ClaimModel } from '../../../../models/ClaimModel'
import { MarketingConsultant } from '../../../../models/MarketingConsultant'
import { ISupportSpinner } from '../../../../shared/Ajax'
import { Backdrop } from '../../../../shared/Backdrop'
import { Option } from '../../../../shared/fields/Options'
import { newGuid, ScheduleTypes } from '../../../../shared/Utility'
import { SaveCancelButtons } from '../../controls/SaveCancelButtons'
import { ScheduleInstructions } from '../../controls/ScheduleInstructions'
import { MarketingConsultantDetails } from './MarketingConsultantDetails'

export interface MarketingConsultantProps {
    history: H.History
    model: ClaimModel
    item: string
    markets: Option<string>[]
    onChange: { (changes: Partial<ClaimModel>, callback?: { (): any }): any }
    addressCountries: Option<string>[]
}

export interface MarketingConsultantState {
    loading: boolean
    model: MarketingConsultant
    existing: boolean
}

export class MarketingConsultantPage extends React.Component<MarketingConsultantProps, MarketingConsultantState> implements ISupportSpinner {
    ajax: ClaimController
    details: MarketingConsultantDetails

    constructor(props: MarketingConsultantProps) {
      super(props)

      this.ajax = new ClaimController()

      this.state = this.getState(props)
    }

    componentDidUpdate(prevProps: MarketingConsultantProps, prevState: MarketingConsultantState) {
      if (this.props.item != prevProps.item) {
        this.setState(this.getState(this.props))
      }
    }

    componentWillUnmount() {
      this.ajax.cancel()
    }

    toggleSpinner(on: boolean, callback: { (): any }): void {
      this.setState({ loading: on }, callback)
    }

    getState(props: MarketingConsultantProps): MarketingConsultantState {
      let model: MarketingConsultant

      const match = props.model.marketingConsultants.filter((r) => r.id == props.item)
      if (match.length > 0) { model = JSON.parse(JSON.stringify(match[0])) } else {
        model = {
          id: newGuid(),
          title: null,
          firstName: '',
          lastName: '',
          tradingName: '',
          acn: '',
          phone: '',
          mobile: '',
          email: '',
          website: '',
          physicalAddress: null,
          postalAddressDifferent: null,
          postalAddress: null,
          relationship: '',
          description: '',
          entries: [],
          consultedFrom: null,
          consultedTo: null,
        }
      }

      return {
        loading: false,
        model,
        existing: match.length > 0,
      }
    }

    remove = () => {
      if (confirm('Remove this consultant?')) {
        const marketingConsultants = this.props.model.marketingConsultants.filter((r) => r.id != this.state.model.id)
        this.props.onChange({ marketingConsultants }, () => {
          this.ajax.updateSchedules(this, this.props.model, ScheduleTypes.MarketingConsultant, () => {
            this.props.history.goBack()
          })
        })
      }
    }

    save = () => {
      this.details.validate((res) => {
        if (res) {
          this.details.table.saveAndClose((res) => {
            if (res) {
              if (this.state.model.entries.filter((r) => r.invalid).length == 0) {
                const marketingConsultants = this.props.model.marketingConsultants.slice()
                let replaceAt = 0
                for (; replaceAt < marketingConsultants.length; replaceAt++) {
                  if (marketingConsultants[replaceAt].id == this.state.model.id) {
                    break
                  }
                }
                if (replaceAt < marketingConsultants.length) {
                  marketingConsultants.splice(replaceAt, 1, this.state.model)
                } else {
                  marketingConsultants.push(this.state.model)
                }

                this.props.onChange({ marketingConsultants }, () => {
                  this.ajax.updateSchedules(this, this.props.model, ScheduleTypes.MarketingConsultant, () => {
                    this.props.history.goBack()
                  })
                })
              } else {
                alert('Please correct records marked with the warning sign.')
              }
            }
          })
        }
      })
    }

    render() {
      return (
        <>
          <SaveCancelButtons onCancel={this.props.history.goBack} onRemove={this.state.existing ? this.remove : null} onSave={this.save} />

          <ScheduleInstructions
            title="Marketing consultant"
            hideApportionmentNote
            helpLink="https://www.austrade.gov.au/ArticleDocuments/6917/Guide-to-Schedule-1B.pdf.aspx"
          />

          <div className="mt-3 mb-3">
            <Alert className="emdg-page-alerts">
              <p>Use a separate schedule for each consultant assignment. Austrade may contact the consultant to verify the activities undertaken and payments made.</p>
            </Alert>
          </div>
          <MarketingConsultantDetails
            ref={(r) => this.details = r}
            id="marketingConsultant"
            model={this.state.model}
            onChange={(c) => this.setState({ model: { ...this.state.model, ...c } })}
            claim={this.props.model}
            addressCountries={this.props.addressCountries}
            markets={this.props.markets}
          />

          <SaveCancelButtons onCancel={this.props.history.goBack} onRemove={this.state.existing ? this.remove : null} onSave={this.save} />

          <Backdrop on={this.state.loading} />
        </>
      )
    }
}
